import type { Notification } from '@parlay-picker/shared/notification';
import type { ReactElement } from 'react';

/** Fallback body — plain text when parsing fails */
export function FallbackBody({ notification }: { notification: Notification }): ReactElement {
  return (
    <div className="mt-2">
      <p className="text-sm text-theme-text leading-snug">{notification.data.summary}</p>
      {notification.data.details && (
        <p className="text-xs text-theme-text-tertiary mt-1">{notification.data.details}</p>
      )}
    </div>
  );
}
